import ThankYouPage from './ThankYouPage'

const RoofingNewQuoteThankYou = () => (
    <ThankYouPage returnPath="/roofing" contentCategory="Roofing" />
)

export default RoofingNewQuoteThankYou
